import React from 'react';

import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import getDateTimeString from '../helpers/getDateTimeString';

import styles from '../styles/insightsDashboardTimestamp.module.scss';

const InsightsDashboardTimestamp = ({ isEmpty, timestamp }) => (
  <div className={styles.element}>
    <div className={styles.header}>
      <div className={styles.headerText}>
        <Typo className={styles.label} color="secondary" element="span" variant="b02">
          {`${i18n.t('last-updated')}:`}
        </Typo>
        <Typo element="span" variant="b01" weight="bold">
          {isEmpty ? i18n.t('not-available') : getDateTimeString(timestamp)}
        </Typo>
      </div>
      <Button
        className={styles.button}
        icon="book"
        isExternalLink
        size="xsmall"
        text={i18n.t('data-dictionary')}
        to="/student?app=data_dictionary"
        variant="link"
      />
    </div>
    <Typo className={styles.description} color="secondary" variant="s01">
      {i18n.t('insights-last-updated-description')}
    </Typo>
  </div>
);

export default React.memo(InsightsDashboardTimestamp);
